import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=019d9f48&scoped=true"
import script from "./star-rating.vue?vue&type=script&lang=ts"
export * from "./star-rating.vue?vue&type=script&lang=ts"
import style0 from "./star-rating.vue?vue&type=style&index=0&id=019d9f48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d9f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019d9f48')) {
      api.createRecord('019d9f48', component.options)
    } else {
      api.reload('019d9f48', component.options)
    }
    module.hot.accept("./star-rating.vue?vue&type=template&id=019d9f48&scoped=true", function () {
      api.rerender('019d9f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/star-rating.vue"
export default component.exports